import * as React from 'react';
const SvgCart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 3.643C2 3.288 2.288 3 2.643 3h.478c.815 0 1.303.548 1.582 1.057.186.34.32.733.425 1.09l.087-.004h10.712c.712 0 1.225.68 1.03 1.365l-1.566 5.494a2.36 2.36 0 0 1-2.267 1.71H8.026a2.36 2.36 0 0 1-2.274-1.733l-.651-2.375-1.08-3.642-.001-.006c-.133-.487-.259-.942-.445-1.281-.18-.33-.325-.39-.454-.39h-.478A.643.643 0 0 1 2 3.644m4.348 5.649.644 2.347c.128.465.551.788 1.034.788h5.098c.478 0 .899-.318 1.03-.778l1.489-5.22H5.502l.834 2.817q.008.022.012.046m2.938 6.994a1.714 1.714 0 1 1-3.429 0 1.714 1.714 0 0 1 3.429 0m-1.286 0a.429.429 0 1 0-.857 0 .429.429 0 0 0 .857 0m7.286 0a1.714 1.714 0 1 1-3.429 0 1.714 1.714 0 0 1 3.429 0m-1.286 0a.429.429 0 1 0-.857 0 .429.429 0 0 0 .857 0"
    />
  </svg>
);
export default SvgCart;
